// Smart Infovision — 17 Experience / Demo Centers across India
// Used for: Branches page, Footer, nearest-demo-center mapping in lead forms.

export const BRANCHES = [
  {
    slug: "noida",
    name: "Smart Infovision Noida",
    city: "Noida",
    state: "Uttar Pradesh",
    address:
      "128, G Block, Sector 63, Noida, Uttar Pradesh 201301",
    map: "https://maps.app.goo.gl/9bjFGkWNVHLihWtb9",
    hero: "Delhi NCR Experience Center",
  },
  {
    slug: "indore",
    name: "Smart Infovision Indore",
    city: "Indore",
    state: "Madhya Pradesh",
    address:
      "302 Appolo Square, 7/1 Dr. R.S. Bhandari Marg, Janjeerwala Square, Indore, Madhya Pradesh 452001",
    map: "https://share.google/visGwugiNaAKu9tDZ",
    hero: "Madhya Pradesh Experience Center",
  },
  {
    slug: "ranchi",
    name: "Smart Infovision Ranchi",
    city: "Ranchi",
    state: "Jharkhand",
    address:
      "Second Floor, Radium Rd, above SBI ATM, Kutchery, Ahirtoli, Ranchi, Jharkhand 834001",
    map: "https://share.google/Xj1fF8k3ABXS8Xl7y",
    hero: "Jharkhand Experience Center",
  },
  {
    slug: "lucknow",
    name: "Smart Infovision Lucknow",
    city: "Lucknow",
    state: "Uttar Pradesh",
    address:
      "TS Tower, 2nd Floor, Ashok Marg, Hazratganj, Lucknow, Uttar Pradesh 226001",
    map: "https://maps.app.goo.gl/CcDMojQtLzXfVQJQ7",
    hero: "Central UP Experience Center",
  },
  {
    slug: "patna",
    name: "Smart Infovision Patna",
    city: "Patna",
    state: "Bihar",
    address:
      "Ground Floor, Sushant Kunj, Behind Jiya Grand Hotel, Opposite Loyola School, Patna, Bihar 800001",
    map: "https://maps.app.goo.gl/j1EpEFwffTp3KLjR6",
    hero: "Bihar Head Office",
  },
  {
    slug: "jaunpur",
    name: "Smart Infovision Jaunpur",
    city: "Jaunpur",
    state: "Uttar Pradesh",
    address:
      "Gaurav City Center, Opposite Gaurav Petrol Pump, Near Power House, Mariahu, Uttar Pradesh 222161",
    map: "https://share.google/03S1nF5zlG5VjZac3",
    hero: "East UP Experience Center",
  },
  {
    slug: "bhagalpur",
    name: "Smart Infovision Bhagalpur",
    city: "Bhagalpur",
    state: "Bihar",
    address:
      "First Floor, 6XW6+7W3, above World Of Physics, Rekab Ganj, Urdu Bazar, Bhagalpur, Bihar 812002",
    map: "https://share.google/tXfrhvn3fYWeVImXb",
    hero: "East Bihar Experience Center",
  },
  {
    slug: "ahmedabad",
    name: "Smart Infovision Ahmedabad",
    city: "Ahmedabad",
    state: "Gujarat",
    address:
      "Office No. 310, 3rd Eye Vision, IIM Road, Opp. Shivalik Plaza, Panjara Pol, University Area, Ahmedabad, Gujarat 380015",
    map: "https://share.google/WYULaE2ShDXR6xvIL",
    hero: "Gujarat Experience Center",
  },
  {
    slug: "jaipur",
    name: "Smart Infovision Jaipur",
    city: "Jaipur",
    state: "Rajasthan",
    address:
      "1st Floor, Unit-2, C-263, Kings Road, Nirman Nagar, Jaipur, Rajasthan 302019",
    map: "https://share.google/t853ay1ewcVYS8LLI",
    hero: "Rajasthan Experience Center",
  },
  {
    slug: "pune",
    name: "Smart Infovision Pune",
    city: "Pune",
    state: "Maharashtra",
    address:
      "Shop No. 5, Ground Floor, Kingston Atlantis, Tehsil Haveli Road, Mahanmadwadi, Mohammed Wadi, Pune, Maharashtra 411060",
    map: "https://share.google/XmBjSF9XVl6FhVVBx",
    hero: "Maharashtra Experience Center",
  },
  {
    slug: "varanasi",
    name: "Smart Infovision Varanasi",
    city: "Varanasi",
    state: "Uttar Pradesh",
    address:
      "S-2/314, Near Sadar Tehsil, Bhojuveer, Varanasi, Uttar Pradesh 221002",
    map: "https://share.google/LPfgaJGrTKSAYHnI2",
    hero: "Purvanchal Experience Center",
  },
  {
    slug: "mumbai",
    name: "Smart Infovision Mumbai",
    city: "Mumbai",
    state: "Maharashtra",
    address:
      "Office No. 1, Raveshia The Metropole, Basement, Jethalal Parikh Rd, near Jhunjhunwala College, Ranwar, Ghatkopar West, Mumbai, Maharashtra 400086",
    map: "https://share.google/rWgSGOsmrQEgmWF5Z",
    hero: "Mumbai Experience Center",
  },
  {
    slug: "kolkata",
    name: "Smart Infovision Kolkata",
    city: "Kolkata",
    state: "West Bengal",
    address:
      "13th Floor, Ergo Tower, A1-4 Block-GP, Sec-5, Salt Lake, Kolkata, West Bengal 700091",
    map: "https://www.google.com/maps/search/?api=1&query=Ergo+Tower+Sector+V+Salt+Lake+Kolkata+700091",
    hero: "East India Experience Center",
  },
  {
    slug: "muzaffarpur",
    name: "Smart Infovision Muzaffarpur",
    city: "Muzaffarpur",
    state: "Bihar",
    address:
      "Nearby Bairiya Bus Stand, Saraswati Colony, Muzaffarpur, Bihar 842001",
    map: "https://maps.google.com/?q=26.147949,85.365074",
    hero: "North Bihar Experience Center",
  },
  {
    slug: "gaya",
    name: "Smart Infovision Gaya",
    city: "Gaya",
    state: "Bihar",
    address: "Smart Infovision Gaya, Bihar",
    map: "https://www.google.com/maps/search/?api=1&query=Smart+Infovision+Gaya+Bihar",
    hero: "South Bihar Experience Center",
  },
  {
    slug: "purnia",
    name: "Smart Infovision Purnia",
    city: "Purnia",
    state: "Bihar",
    address: "Smart Infovision Purnia, Bihar",
    map: "https://www.google.com/maps/search/?api=1&query=Smart+Infovision+Purnia+Bihar",
    hero: "Seemanchal Experience Center",
  },
  {
    slug: "siliguri",
    name: "Smart Infovision Siliguri",
    city: "Siliguri",
    state: "West Bengal",
    address: "Smart Infovision Siliguri, West Bengal",
    map: "https://www.google.com/maps/search/?api=1&query=Smart+Infovision+Siliguri+West+Bengal",
    hero: "North Bengal Experience Center",
  },
];

// Shared contact info (kept here so it stays consistent across the whole app)
export const COMPANY = {
  sales_phone: "+91-8527926648",
  sales_phone_digits: "918527926648",
  service_phone: "+91-7090022211",
  service_phone_digits: "917090022211",
  email: "Service@smartinfovision.com",
  website: "https://www.smartinfovision.com",
  youtube: "https://www.youtube.com/@STUDIOSETUPBYSMARTINFOVISION",
  youtube_main: "https://www.youtube.com/c/SmartInfovision",
  facebook: "https://www.facebook.com/SmartInfovision",
  instagram: "https://instagram.com/smartinfovision",
  twitter: "https://twitter.com/CHANDAN44066398",
  whatsapp_link: "https://wa.me/918527926648",
  // Specialised consultation numbers (used on dedicated tools)
  studio_whatsapp: "https://wa.me/919560805022",
  studio_whatsapp_digits: "919560805022",
  acoustic_whatsapp: "https://wa.me/919560805022",
  acoustic_whatsapp_digits: "919560805022",
};

// State -> ordered list of nearest branch slugs (closest first).
// Used to auto-pick the right demo center when a user is on a state/city page
// or fills the lead form. We pick by geographic adjacency rather than km calc.
export const STATE_NEAREST_BRANCHES = {
  "uttar pradesh": ["noida", "lucknow", "jaunpur", "varanasi"],
  "delhi": ["noida"],
  "haryana": ["noida"],
  "uttarakhand": ["noida", "lucknow"],
  "himachal pradesh": ["noida"],
  "punjab": ["noida"],
  "chandigarh": ["noida"],
  "jammu and kashmir": ["noida"],
  "ladakh": ["noida"],

  "bihar": ["patna", "muzaffarpur", "gaya", "purnia", "bhagalpur", "varanasi"],
  "jharkhand": ["ranchi", "patna", "bhagalpur"],
  "west bengal": ["kolkata", "siliguri", "ranchi", "patna", "bhagalpur"],
  "odisha": ["kolkata", "ranchi", "patna"],
  "sikkim": ["siliguri", "kolkata", "ranchi", "patna"],
  "meghalaya": ["siliguri", "kolkata", "ranchi", "patna"],
  "tripura": ["siliguri", "kolkata", "ranchi", "patna"],
  "manipur": ["siliguri", "kolkata", "ranchi", "patna"],
  "nagaland": ["siliguri", "kolkata", "ranchi", "patna"],
  "mizoram": ["siliguri", "kolkata", "ranchi", "patna"],
  "arunachal pradesh": ["siliguri", "kolkata", "ranchi", "patna"],
  "assam": ["siliguri", "kolkata", "ranchi", "patna"],

  "madhya pradesh": ["indore", "jaipur"],
  "chhattisgarh": ["indore", "ranchi", "patna"],
  "rajasthan": ["jaipur", "indore", "noida"],
  "gujarat": ["ahmedabad", "indore", "pune"],
  "maharashtra": ["mumbai", "pune", "ahmedabad"],
  "goa": ["mumbai", "pune"],

  "karnataka": ["pune", "mumbai", "ahmedabad"],
  "telangana": ["pune", "mumbai", "ahmedabad"],
  "andhra pradesh": ["pune", "mumbai", "ahmedabad"],
  "tamil nadu": ["pune", "mumbai", "ahmedabad"],
  "kerala": ["pune", "mumbai", "ahmedabad"],
  "puducherry": ["pune", "mumbai"],

  "dadra and nagar haveli and daman and diu": ["mumbai", "ahmedabad", "pune"],
  "lakshadweep": ["mumbai", "pune"],
  "andaman and nicobar islands": ["ranchi"],
};

const BRANCH_BY_SLUG = BRANCHES.reduce((m, b) => ({ ...m, [b.slug]: b }), {});

/**
 * Given a state name (case-insensitive), return the nearest branch object
 * plus an array of alternates. Falls back to Noida if state not recognised.
 */
export function nearestBranchForState(stateName) {
  if (!stateName) return { primary: BRANCH_BY_SLUG.noida, alternates: [] };
  const key = stateName.toLowerCase().trim();
  const ordered = STATE_NEAREST_BRANCHES[key] || ["noida"];
  const slugs = ordered.filter((s) => BRANCH_BY_SLUG[s]);
  if (slugs.length === 0) return { primary: BRANCH_BY_SLUG.noida, alternates: [] };
  return {
    primary: BRANCH_BY_SLUG[slugs[0]],
    alternates: slugs.slice(1).map((s) => BRANCH_BY_SLUG[s]),
  };
}

export function getBranchBySlug(slug) {
  return BRANCH_BY_SLUG[slug];
}
